import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useGetVsic from '../../../../common/category/useGetVsic'
import { Loading } from '../../../../common/loading'
import { COMPANY_TYPES } from '../../../../utils/common'
import { selectCompanyInfo } from '../../../common/header/companyInfo/store/slice'
import { getDefaultVsic } from '../../helper'
import '../lang/i18n'
import {
  changeIndustry,
  resetForNewCompany,
  selectCurrentMainVsicId,
  selectIsFirstLoad,
} from '../store/slice'
import { Content } from './Content'

export const Bottom = () => {
  const dispatch = useDispatch()

  const { vsics } = useGetVsic()
  const { mainVsicId, companyType } = useSelector(selectCompanyInfo)
  const isFirstLoad = useSelector(selectIsFirstLoad)
  const currentMainVsicId = useSelector(selectCurrentMainVsicId)

  useEffect(() => {
    if (mainVsicId && mainVsicId !== currentMainVsicId) {
      if (vsics.length && companyType === COMPANY_TYPES.CORPORATE) {
        const defaultVsic = getDefaultVsic(vsics, mainVsicId)

        dispatch(
          resetForNewCompany({
            defaultIndustry: defaultVsic?.id,
            mainVsicId,
          }),
        )
      }
    } else if (!mainVsicId && currentMainVsicId) {
      dispatch(
        changeIndustry({
          type: 'defaultIndustry',
          value: undefined,
        }),
      )
    }
  }, [mainVsicId, currentMainVsicId, vsics])

  if (
    !companyType ||
    (!isFirstLoad && companyType === COMPANY_TYPES.CORPORATE)
  ) {
    return <Loading />
  }

  return <Content vsics={vsics} />
}
